import React from 'react';

export const PlusButtonIcon = () => (
  <span style={{ paddingRight: '8px' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6V10H6V6H10V4H6V0H4V4H0V6H4Z"
        fill="white"
      />
    </svg>
  </span>
);
